<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BRVW0m/CoverDesign.jpg?1685327317878" alt="This image is the cover for the book Andrew's Promise, Heroes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Andrew's Promise, Heroes
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Heroes: Book Two</i></b></p><p>Young mechanic Andrew Campbell’s life couldn’t be better. He is about to restore a Ford Mustang with his dad before heading off on the ultimate cross-country road trip with his best friend, Tanner McKenzie.</p> <p>But tragedy strikes, and Andrew’s life is shattered. Worried his family will be torn apart if he doesn’t step in, Andrew makes a tough choice between following his heart and doing what he needs to do to protect his little brother.</p> <p>When Andrew pushes Tanner away, Tanner heads off on the planned trip alone. Once Tanner leaves town, his life takes a different path, and it’s ten years before he returns. Now a firefighter, he’s never forgotten his first love, and no one has ever taken Andrew’s place in his heart. He’s determined to see if Andrew feels the same way. He just hopes Andrew’s excited to see him, hopes that he’s available—and finally out—after all this time.</p> <p>They might not have been ready to deal with emerging feelings years ago, but now might be the time for their second chance at love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nic Starr
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?abc45730